import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';

import styles from '../index.module.scss';

const Dropdown = ({ data, children, ...other }) => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);

	const onTriggerClick = () => {
		setDropdownOpen(!dropdownOpen);
		document.addEventListener('click', onCloseMenu);
	};

	const onCloseMenu = (e) => {
		if (e.target && dropdownRef?.current && !dropdownRef.current.contains(e.target)) {
			setDropdownOpen(false);
			document.removeEventListener('click', onCloseMenu);
		}
	};

	return (
		<div ref={dropdownRef}>
			<button
				type='button'
				data-gtm-linktype='navigation'
				data-gtm-linktext={data.menu_heading}
				aria-haspopup='true'
				aria-expanded={dropdownOpen}
				onClick={() => onTriggerClick()}
				className={`${styles.header_DropdownTrigger} ${dropdownOpen ? styles.header_DropdownTrigger_active : ''}`}
				{...other}
			>
				{data.menu_heading}
				<Icon name='expand_more' />
			</button>

			<div
				aria-hidden={!dropdownOpen}
				className={`${styles.header_Dropdown} ${dropdownOpen ? styles.header_Dropdown_active : ''}`}
			>
				{dropdownOpen && children}
			</div>
		</div>
	);
};

Dropdown.propTypes = {
	data: PropTypes.object,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default Dropdown;
